
import { Component, Vue } from 'vue-property-decorator'
import { OperationPointsService, OperationPointsDto,SchoolService } from "@/api/service-proxies";
import SchoolSelector from '../components/school-selector.vue'
@Component({
    name: "totalPoint",
    components: {
         SchoolSelector
    }
})
export default class pointRuls extends Vue {
    OperationPoints=new OperationPointsService()
    schoolService = new SchoolService();
    list=[]
    tablelist=[]
    isTableLoading=false
    schoolname=''
    mounted() {
       this.isTableLoading=true
    this.schoolService.getUserSchools().then((result) => {
      this.list = result.items;
     this.tablelist=result.items
      this.isTableLoading=false
    });

    }
    search(){
        this.tablelist = this.list.filter(x=>x.name.includes(this.schoolname))
    }
    goback(){
        this.$router.back()
    }
    schoolChange(event: any) {
        // this.request.tenantId = event.tenantId
    }

    handleUpdate(msg) {
        // this.$router.push({ path: '/editorPointRuls', query: { id: c }})
        this.$router.push({
            name: "/editorPointRuls",
            query: { id: msg.id },
        });
        // this.$router.push({ path: `/Coupon/update/${Coupon.id}` });
    }
}
